import React from 'react'
import { Typography, useTheme } from '@mui/material'
import { DESKTOP_ILLUSTRATION_HEIGHT, DESKTOP_ILLUSTRATION_WIDTH, EMPTY_BANNER_SIZE } from './constants'
import { BannerContainer, IllustrationContainer } from './styles'
import type { EmptyBannerProps } from './types'

const EmptyBanner: React.FC<EmptyBannerProps> = ({ illustration: Illustration, text, isSmallScreen, size }) => {
  const { palette } = useTheme()
  const isSizeSmall = size === EMPTY_BANNER_SIZE.small
  const illustrationSize = isSmallScreen
    ? {}
    : { width: DESKTOP_ILLUSTRATION_WIDTH, height: DESKTOP_ILLUSTRATION_HEIGHT }

  return (
    <BannerContainer>
      <IllustrationContainer
        isSmallScreen={isSmallScreen}
        data-testid="empty-banner-illustration"
        isSizeSmall={isSizeSmall}
      >
        <Illustration {...illustrationSize} />
      </IllustrationContainer>
      {text && (
        <Typography
          align="center"
          variant={isSizeSmall ? 'h6' : 'h5'}
          color={palette.text.primary}
          data-testid="empty-banner-text"
        >
          {text}
        </Typography>
      )}
    </BannerContainer>
  )
}

export default EmptyBanner
